export class NetworkError extends Error {
  constructor(
    message: string,
    public status?: number,
    public code?: string,
  ) {
    super(message);
    this.name = "NetworkError";
  }
}

export const fetchWithRetry = async <T>(
  fetchFn: () => Promise<T>,
  options: {
    maxRetries?: number;
    retryDelay?: number;
    shouldRetry?: (error: any) => boolean;
  } = {},
): Promise<T> => {
  const {
    maxRetries = 3,
    retryDelay = 1000,
    shouldRetry = (error) => {
      return (
        error?.status === "FETCH_ERROR" ||
        error?.status >= 500 ||
        error?.status === undefined
      );
    },
  } = options;

  let lastError: any;

  for (let attempt = 0; attempt <= maxRetries; attempt++) {
    try {
      return await fetchFn();
    } catch (error: any) {
      lastError = error;

      if (
        error?.status === 400 ||
        error?.status === 401 ||
        error?.status === 403 ||
        error?.status === 404
      ) {
        throw error;
      }

      if (attempt < maxRetries && shouldRetry(error)) {

        const delay = retryDelay * Math.pow(2, attempt);
        await new Promise((resolve) => setTimeout(resolve, delay));
        continue;
      }

      break;
    }
  }

  throw lastError;
};

export const isNetworkError = (error: any): boolean => {
  return (
    error?.status === "FETCH_ERROR" ||
    error?.name === "TypeError" ||
    error?.message?.includes("Failed to fetch") ||
    error?.message?.includes("Network request failed")
  );
};
